var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.499 24.0713C17.194 23.9908 22.9775 23.9908 23.6982 24.0713C25.3384 24.2546 26.7778 24.7768 28.1797 25.6973C29.3237 26.4485 30.526 27.7129 31.1855 28.8574C31.2481 28.9664 31.2294 29.1044 31.1396 29.1924L30.6572 29.666C29.7725 30.533 28.8985 31.2196 27.9434 31.7988C25.3309 33.3826 22.3484 34.1394 19.3545 33.9785C17.5901 33.8836 16.1137 33.5588 14.4883 32.9072C12.6408 32.1665 11.0467 31.1165 9.56641 29.666L9.08301 29.1924C8.99326 29.1043 8.97437 28.9664 9.03711 28.8574C9.69664 27.7128 10.8989 26.4485 12.043 25.6973C13.4297 24.7868 14.8721 24.2606 16.499 24.0713Z",
    fill: "#e55496"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1836 9.05859C19.606 8.98168 20.5739 8.98051 21.0098 9.05664C22.5841 9.3321 23.9059 10.1805 24.7686 11.4697C25.2732 12.2242 25.5328 12.8985 25.6836 13.8477C25.7469 14.2476 25.7112 15.323 25.6211 15.7354C25.3303 17.066 24.5879 18.2526 23.5605 19.0293C23.0471 19.4174 22.554 19.6945 22.0576 19.8721C20.9612 20.264 19.8626 20.3227 18.7588 20.0488C16.657 19.5271 15.0703 17.8804 14.6016 15.7354C14.5115 15.3229 14.4757 14.2476 14.5391 13.8477C14.6899 12.8984 14.9493 12.2243 15.4541 11.4697C16.3084 10.1929 17.6233 9.34309 19.1836 9.05859Z",
    fill: "#e55496"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0C31.0457 0 40 8.9543 40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0ZM20 2C10.0589 2 2 10.0589 2 20C2 29.9411 10.0589 38 20 38C29.9411 38 38 29.9411 38 20C38 10.0589 29.9411 2 20 2Z",
    fill: "#e55496"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/UserIcon.d10163d4eaecd4cdb3b39e0ef0a8b158.svg";
export { ForwardRef as ReactComponent };